import { sendPostRequest } from "services/apiService";

const renameEventFloors = (
  eventId: string,
  theaterId: string,
  floorNames: Record<string, string>,
) =>
  sendPostRequest<{ floorNames: Record<string, string> }, APIResponse>(
    `/event/${eventId}/${theaterId}/floor-names`,
    {
      floorNames,
    },
  );

export default {
  renameEventFloors,
};
